import { type CSSProperties } from "react";

import clsx from "clsx";

export default function Spinner({
  size = "sm",
  colorClassname = "text-cosmic",
  style,
}: {
  size?: "sm" | "md" | "lg";
  colorClassname?: string;
  style?: CSSProperties;
}) {
  return (
    <span
      className={clsx(
        `spinner-border spinner-border-${size} aspect-square`,
        colorClassname,
      )}
      role="status"
      aria-hidden="true"
      style={style}
    />
  );
}
